import type { MapVenue } from '../../../../api/regions';
import { SectionCard } from '../../regional/BucketStates';

interface Props {
  venues: MapVenue[];
  /** Full region chain for a venue's most-specific region (root → deepest). */
  chainOf: (regionId: string | null) => string[];
}

/**
 * Venues that are members of this region — assigned to it or any subregion.
 * Each row shows the venue's full region chain (e.g. California › SoCal › LA
 * County) so the rolled-up membership is legible.
 */
export function RegionVenueList({ venues, chainOf }: Props) {
  return (
    <SectionCard title={`Venues (${venues.length})`}>
      {venues.length === 0 ? (
        <div style={{ padding: '6px 4px', fontSize: 12.5, color: 'var(--nb-subtle)' }}>
          No venues in this region or its subregions yet.
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            maxHeight: 260,
            overflow: 'auto',
          }}
        >
          {venues.map((v) => (
            <div key={v.id} style={{ padding: '7px 10px', borderRadius: 8 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--nb-ink)' }}>{v.name}</div>
              <div style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>
                {[v.city, v.state].filter(Boolean).join(', ')}
              </div>
              {v.regionId && (
                <div style={{ fontSize: 10.5, color: 'var(--nb-muted)', marginTop: 2 }}>
                  {chainOf(v.regionId).join(' › ')}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
}
